import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import messages from 'assets/Local/messages';
import manIcon from 'assets/images/ic_man.png';
import jobIcon from 'assets/images/ic_job.png';
import appIcon from 'assets/images/ic_app.png';
import cvIcon from 'assets/images/ic_cv.png';
import puzzIcon from 'assets/images/ic_puzz.png';
import teamIcon from 'assets/images/ic_team.png';
import vidIcon from 'assets/images/ic_vid.png';
import cloudIcon from 'assets/images/ic_cloud.png';

import './Services.scss';

const Services = () => {
	const lang = useSelector((state) => state.locale.lang);
	const message = messages[lang];
	const cardRender = (icon, title, description) => {
		return (
			<div className="d-flex flex-column text-center service-card">
				<div className="icon mb-4">
					<img src={icon} alt={title} />
				</div>
				<h3 className="mb-3 text-uppercase bold_font">{title}</h3>
				<p className="description semi_bold_font">{description}</p>
			</div>
		);
	};

	return (
		<div className="services text-center container" >
			<div className="title mb-4 mx-auto">
        <h2 className='main-title bold_font mb-4 mx-auto' data-aos="fade-up"  data-aos-duration="1000">{message.serviceSection.excitedToKnow}</h2>

				<h2 className="sec-title bold_font my-5" data-aos="fade-up"  data-aos-duration="1500">{message.serviceSection.ourFeatures}</h2>
			</div>

			<div className="row mx-2" data-aos="fade-up"  data-aos-duration="1000" data-aos-delay="500">
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(manIcon, message.serviceSection.manpowerRequest.name, message.serviceSection.manpowerRequest.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(jobIcon, message.serviceSection.jobAdvertising.name, message.serviceSection.jobAdvertising.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(appIcon, message.serviceSection.hiringPipeline.name, message.serviceSection.hiringPipeline.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(cloudIcon, message.serviceSection.CloudArchive.name, message.serviceSection.CloudArchive.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(vidIcon, message.serviceSection.videoInterviewing.name, message.serviceSection.videoInterviewing.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(teamIcon, message.serviceSection.teamCollaboration.name, message.serviceSection.teamCollaboration.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(cvIcon, message.serviceSection.cvParsing.name, message.serviceSection.cvParsing.description)}
        </div>
				<div className="col-lg-3  col-sm-6   mb-3">
          {cardRender(puzzIcon, message.serviceSection.multipleIntegrations.name, message.serviceSection.multipleIntegrations.description)}
        </div>
			</div>
		</div>
	);
};

export default Services;
